<template lang="pug">
    .resource-row
        input(type="radio" :id="labelId" name="resources" @change="pickedResource")
        label(:for="labelId")
            .column.thumb-column
                .resource-thumb( :style="{ backgroundImage: `url(${resource.feature_image.path})` }" @click="showPopup")
                .resource-details
                    h4 {{ resource.hall_name }}
                    p.cost {{ currency }} {{ fee }} Per day

            .column
                p {{ resource.brief_description }}
                                    
            .column
                a(href="" @click.prevent="clickedRoom") More details                                  

</template>

<script>
    import _ from 'lodash';
    import { mapGetters, mapActions } from 'vuex';  

    export default {
        name: "Room",
        data() {
            return {
                labelId: null,
                currency: 'USD',
                fee: 0
            }
        },
        computed: mapGetters(['getCurrency', 'currencyDetails']),
        props: ['resource'],
        methods: {
            ...mapActions(['getRates']),
            showPopup() {
                this.$refs.selectedResourcePopup.toggle();
            },
            clickedRoom() {
                this.$emit('clickedRoom', {
                    'resource_id' : this.resource.id
                });                
            },
            pickedResource(event) {
                if(event.target.checked) {
                    this.$emit('pickedResource', { 'id': this.resource.id, 'price': this.resource.price_per_day })
                }
            },
            updateFee() {
                this.currency = 'USD';
                this.fee = this.resource.price_per_day
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                        this.fee = this.resource.price_per_day * this.currencyDetails.lkr;
                    });
                } else {
                   this.updateFee() 
                }
            },                        
        },
        mounted() {
            this.labelId = _.uniqueId();
            this.onCurrencyUpdate();
        },
        watch: {
            getCurrency: {
                handler: function() {
                    this.onCurrencyUpdate();
                }
            }
        }        
    };
</script>

<style lang="sass">
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_resource.sass"
</style>

